import { LogoContainerWrapper, OfficeModalWrapper } from "./styles";
import { OfficeInfo } from "./OfficeInfo";
import { ReactSVG } from "react-svg";
import { useState } from "react";
import React from "react";
import infoIcon from "views/resources/icons/infoIcon.svg";
import logos from "views/resources/logos/SVG";

export const LogoContainer = ({ showLogo, logo, office }) => {
	const [showOfficeModal, setShowOfficeModal] = useState(false);
	const onClose = () => {
		setShowOfficeModal(false);
	};
	const checkOffice = () => {
		setShowOfficeModal(true);
	};
	return (
		<LogoContainerWrapper>
			<img
				src={
					showLogo ? logo : logos[`logo_${office.category_id}_color`]
				}
			/>

			<ReactSVG
				className="button-to-show-info"
				src={infoIcon}
				onClick={checkOffice}
			/>

			<OfficeModal
				office={office}
				onClose={onClose}
				visible={showOfficeModal}
			/>
		</LogoContainerWrapper>
	);
};

const OfficeModal = ({ office, onClose, visible }) => {
	return (
		<OfficeModalWrapper
			onCancel={onClose}
			visible={visible}
			footer={false}
			mask={false}
		>
			<OfficeInfo office={office} logos={logos} />
		</OfficeModalWrapper>
	);
};
